module.exports = __webpack_public_path__ + "img/icon_pinpai.28c129dc.svg";